/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const AccountTitleDetailState = Record({
  id: null,
  account_title_group_id: null,
  account_title_group_name: '',
  account_title_id: null,
  account_title_name: '',
  name: '',
  position: null,
  cost_type: 'unrelated'
})

export default AccountTitleDetailState
